const handler = (toggleElement) => {
    const hiddenSiblings = toggleElement.parentNode.querySelectorAll("input[type='hidden']");

    hiddenSiblings.forEach((el) => {
        if (toggleElement.checked) {
            el.name = el.dataset.name;
        } else {
            el.name = '';
        }
    });
};

export const multipleFormFieldsListener = () => {
    const multipleFormFieldElements = [
        ...document.querySelectorAll('.js-multiple-form-fields'),
    ].filter((el) => !el.dataset.multipleFormFieldsInitialized);

    multipleFormFieldElements.forEach((el) => {
        el.addEventListener('change', () => {
            handler(el);
        });

        el.dataset.multipleFormFieldsInitialized = true;
    });
};
